
export const createPilotPilotagesUrl = () => {
    return `/pilot/pilotages`;
}

export const createPilotPilotageDetailsUrl = (pilotageId: string | number) => {
    return `${createPilotPilotagesUrl()}/details/${pilotageId}`;
}

export const createPilotageCurrentDetailsUrl = (pilotageId: string | number) => {
    return `/pilotages/current/details/${pilotageId}`;
}
